var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgError(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 34,
    height: 34,
    rx: 17,
    stroke: "#CE1331",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 8C23.523 8 28 12.478 28 18C28 23.522 23.523 28 18 28C12.477 28 8 23.522 8 18C8 12.478 12.477 8 18 8ZM18.0018 21.0037C17.4503 21.0037 17.0031 21.4508 17.0031 22.0024C17.0031 22.5539 17.4503 23.001 18.0018 23.001C18.5533 23.001 19.0005 22.5539 19.0005 22.0024C19.0005 21.4508 18.5533 21.0037 18.0018 21.0037ZM17.9996 13C17.4868 13.0002 17.0643 13.3864 17.0067 13.8837L17 14.0004L17.0018 19.0012L17.0086 19.1179C17.0665 19.6152 17.4893 20.0011 18.0022 20.0009C18.515 20.0007 18.9375 19.6145 18.9951 19.1171L19.0018 19.0005L19 13.9996L18.9932 13.883C18.9353 13.3857 18.5125 12.9998 17.9996 13Z",
    fill: "#CE1331"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.e1a6cd7312e15447f869ed44d509cc2b.svg";
export { ForwardRef as ReactComponent };